export const API_SUCCESS = 'succeeded';

export const API_FAIL = 'failed';
